import React from 'react'
import styled from 'styled-components'
import { containerDefaultStyles } from 'styles/defaults'
import TikTok from 'images/magic/tiktok.svg'
import Linkedin from 'images/magic/linkedin.svg'
import Instagram from 'images/magic/instagram.svg'
import mediaQuery from '../../styles/mediaQuery'
import colors from '../../styles/colors'

const Section = styled.div`
  background: #000;
  padding: 24px 0;
`

const SectionContainer = styled.div`
  ${containerDefaultStyles};

  ${mediaQuery.mobile} {
    text-align: center;
  }

  ${mediaQuery.tabletMin} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

const Copyright = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  color: ${colors.gray2};
`

const Links = styled.div`
  display: flex;
  order: 2;
  align-items: center;
  justify-content: center;

  ${mediaQuery.mobile} {
    margin-bottom: 15px;
  }
`

const LinkStyled = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 16px;
  background: #18181c;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;

  &:hover {
    opacity: 0.8;
  }

  &:last-child {
    margin-right: 0;
  }
`

const Footer = () => (
  <Section>
    <SectionContainer>
      <Links>
        <LinkStyled
          href="https://www.instagram.com/joinflip/"
          aria-label="Instagram"
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          <Instagram />
        </LinkStyled>
        <LinkStyled
          href="https://www.tiktok.com/@joinflip"
          aria-label="TikTok"
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          <TikTok />
        </LinkStyled>
        <LinkStyled
          href="https://www.linkedin.com/company/myflipfit"
          aria-label="Linkedin"
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          <Linkedin />
        </LinkStyled>
      </Links>
      <Copyright>
        All Rights Reserved Human Inc {new Date().getFullYear()}.
      </Copyright>
    </SectionContainer>
  </Section>
)

export default Footer
